import React, { useEffect } from 'react'
import { getLocalStorageItem, setLocalStorageItem } from '@afterpay/utils/storage'
import { useFlag } from '@afterpaytouch/feature'
import { Theme, ToastItem, useGetSelectedTheme, useToast } from '@afterpaytouch/core'
import { Features } from '../../model'
import { useTranslation } from '../../utils/convergence'

const STORAGE_KEY = 'arcade_reassurance_shown'
const PERSISTENT_TOAST_TIME = 0

const hasBeenShown = (): boolean => getLocalStorageItem<boolean>(STORAGE_KEY, false) === true

const markShown = (): void => {
  setLocalStorageItem(STORAGE_KEY, true)
}

export const useShowReassuranceToast = (): void => {
  const { t } = useTranslation()
  const setToast = useToast()
  const flagEnabled = useFlag<boolean>(Features.MONOCHROME_NEW_DESIGN_TOAST, false)
  const theme = useGetSelectedTheme()
  const isKelpieOrKelpieMint = theme === Theme.Kelpie || theme === Theme.KelpieMint

  useEffect(() => {
    if (!flagEnabled) return
    if (!isKelpieOrKelpieMint) return
    if (hasBeenShown()) return

    markShown()

    setToast({
      message: () => (
        <>
          <ToastItem.Headline testNameSpace='reassurance-toast-headline'>{t('common:reassuranceToast.headline')}</ToastItem.Headline>
          <ToastItem.Body testNameSpace='reassurance-toast-body'>{t('common:reassuranceToast.body')}</ToastItem.Body>
        </>
      ),
      manualDismiss: true,
      toastTime: PERSISTENT_TOAST_TIME,
      testNameSpace: 'reassurance',
    })
  }, [flagEnabled, isKelpieOrKelpieMint, setToast, t])
}
